export default __webpack_public_path__ + "static/media/the_Product-one.e2842415.png";